<template>
  <button
    type="button"
    :class="b('', { active })"
    :aria-label="$t('e-button-hamburger.aria-label-button')"
    @click="onClick"
  >
    <span :class="b('box')">
      <span :class="b('line')"></span>
      <span :class="b('line')"></span>
      <span :class="b('line')"></span>
    </span>
  </button>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  // type Setup = {};
  type Data = {
    active: boolean;
  };

  export default defineComponent({
    name: 'e-button-hamburger',

    emits: {
      click: (() => true) as (active: boolean) => void,
    },

    // components: {},

    // props: {},
    // setup(): Setup {},
    data(): Data {
      return {
        active: false,
      };
    },

    // computed: {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    methods: {
      onClick() {
        this.active = !this.active;

        this.$emit('click', this.active);
      },
    },
    // render() {},
  });
</script>

<style lang="scss">
  .e-button-hamburger {
    $this: &;
    $_amount-lines: 3;
    $_amount-spaces: 2;
    $_hamburger-width: 22px;
    $_hamburger-line-height: 2px;
    $_hamburger-line-spacing: 4px;
    $_hamburger-height: $_hamburger-line-height * $_amount-lines + $_hamburger-line-spacing * $_amount-spaces;

    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    position: relative;
    width: 100%;
    height: 100%;
    border: 0;
    padding: 0;
    background: 0 0;

    &--active {
      #{$this}__line:first-child {
        display: none;
      }

      #{$this}__line:nth-child(2),
      #{$this}__line:last-child {
        background-color: var(--theme-color-grayscale--1000);
        top: $_hamburger-line-height * $_amount-lines;
      }

      #{$this}__line:nth-child(2) {
        transform: rotate(45deg);
      }

      #{$this}__line:last-child {
        transform: rotate(-45deg);
      }
    }

    &__box {
      position: relative;
      width: $_hamburger-width;
      height: $_hamburger-height;
    }

    &__line {
      position: absolute;
      width: $_hamburger-width;
      height: $_hamburger-line-height;
      background-color: var(--theme-color-grayscale--900);
      transition: all 0.3s ease-in-out;

      &:first-child {
        top: 0;
      }

      &:nth-child(2) {
        top: calc(50% - calc($_hamburger-line-height / $_amount-spaces));
      }

      &:last-child {
        bottom: 0;
      }
    }
  }
</style>
